<template>
  <div id="app">

    <router-view v-title="$route.meta.title"/>


  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {}
  },
  components: {},
  mounted: function () {

  },
  watch: {}
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

*, *:before, *:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none !important;
}

body {
  margin: 0px;
  padding: 0px;
  font-size: 12px;
  font-family: "微软雅黑";
  color: #000;
  line-height: 1;
  background: #011346;
  overflow: hidden;
}

ul, li, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, ol, form, input {
  margin: 0px;
  padding: 0px;
}

input, textarea {
  font-family: "微软雅黑";
  border: none;
  outline: none;
  background: transparent !important;
  box-shadow: none;
  -webkit-appearance: none;
}

select {
  font-family: "微软雅黑";
  border: none;
  outline: none;
  background: none;
  box-shadow: none;
}

ul, li {
  list-style: none
}

i {
  font-style: normal;
}

.head {
  height: 11vh;
  padding: 0 2.8vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url(assets/a00.png) no-repeat top center / 100% 16vh;
  overflow: hidden;
  padding-bottom: 2.5vh;
  position: relative;
}

.head .logo {
  display: block;
  height: 7vh;
}

.head .logo img {
  display: block;
  height: 7vh;
}

.head .area {
  display: block;
  cursor: pointer;
  background: url(assets/a01.png) no-repeat center center / 100% 100%;
  height: 4.9vh;
  padding: 0 2vw; /*width: 7.4vw;*/
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;
  color: #00bfe9;
}

.head .back {
  display: block;
  cursor: pointer;
  background: url(assets/a01.png) no-repeat center center / 100% 100%;
  height: 4.4vh;
  padding: 0 1.5vw;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9vw;
  color: #00bfe9;
  position: absolute;
  left: 12vw;
  top: 2.3vh;
}

.head .tit {
  display: block;
  height: 4.6vh;
  line-height: 4.6vh;
  position: absolute;
  left: 20%;
  right: 20%;
  top: 2.2vh;
  z-index: 1;
  width: 60%;
  text-align: center;
  font-size: 1.8vw;
  color: #fff;
  font-weight: bold;
  text-shadow: #00d4ff 1px 2px 3px
}

.head .tit img {
  display: block;
  height: 4.6vh;
  margin: 0 auto;
}

.head .time {
  color: #00bfe9;
  font-size: 1.1vw;
}

.main {
  height: 89vh;
  padding: 2vh 0.3vw;
}

.numlist {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.numlist .item {
  width: 16.5%;
  height: 9.9vh;
  background-color: #0c2965;
  border-radius: 8px;
  border: solid 1px #1347ab;
  display: flex;
  align-items: center;
  justify-content: center;
}

.numlist .item > img {
  display: block;
  height: 5vh;
  margin-right: 0.8vw;
}

.numlist .item .txt {
  color: #fff;
  line-height: 1.3;
}

.numlist .item .txt h6 {
  font-size: 0.8vw;
}

.numlist .item .txt p {
  display: flex;
  align-items: center;
  font-size: 0.9vw;
  color: #00d4ff;
}

.numlist .item .txt p b {
  font-weight: bold;
  font-size: 1.2vw;
}

.numlist .item .txt .up {
  display: block;
  color: #cd6868;
}

.scrollbar::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #00d4ff;
}

.scrollbar::-webkit-scrollbar-track {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}

</style>



// WEBPACK FOOTER //
// src/App.vue